import zipcodes from './zipcodes/data.json';

export default class ZipcodeService {
    lookupState(zipcode) {
        return zipcodes[zipcode];
    }
}

ZipcodeService.instance = new ZipcodeService();